import DResultsFirst from './DResultsFirst'

export default DResultsFirst
